// extracted by mini-css-extract-plugin
module.exports = {"pre-wrap":"NativeType_pre-wrap__apGot"};